import { ref } from 'vue';
import { sendSms } from '@/api/login';
import { ElMessage } from 'element-plus'
import regexp from '@/utils/regexp';
import encrypt from '@/utils/encrypt';

// 获取验证码
export function useSendCode () {
  const isSending = ref(false);
  const countdown = ref(0);
  let countdownInterval;

  const clear = () => {
    isSending.value = false;
    countdown.value = 0;
    clearInterval(countdownInterval);
  }

  // smsType 1: 注册 2:密码找回 3:修改密码 4:修改邮箱
  const sendCode = (phone, smsType = 1) => {
    if (!phone) {
      ElMessage.warning('请输入联系电话');
      return
    };

    if (!regexp.phone.test(phone)) {
      ElMessage.warning('手机号码格式有误');
      return
    };

    isSending.value = true;
    countdown.value = 60;
    countdownInterval = setInterval(() => {
      countdown.value -= 1;
      if (countdown.value <= 0) {
        clear();
      }
    }, 1000);
    sendSms({ smsType, phone: encrypt(phone) }).then(res => {
      if (!res) {
        // isSending.value = false;
        // countdown.value = 0;
        // clear();
      }
    })
  };

  return {
    isSending,
    countdown,
    sendCode,
    clear,
  }
}